export default "__VITE_ASSET__BOFgZOkY__"